import React, { useCallback, useEffect, useState } from "react";
import Colors from "../../../../../../constants/Colors";
import useResponsiveInfo from "../../../../../../hooks/useResponsiveInfo";
import {
  ModalAttendanceButtonsContainer,
  ModalAttendanceCardContainer,
  ModalAttendanceTextCardContainer,
  AttendanceCardModal,
  AttendanceCardModalContainer,
  AttendanceModalOverFlow,
} from "./ModalAttendanceRecord.styled";
import {
  H1,
  Text,
  TitleLarge,
} from "../../../../../../components/UI/generalLayout/Layout.styled";
import { Spacer } from "../../../../../../components/UI/spacer/spacer";
import { Button } from "../../../../../company/companyRegister/CompanyRegister.styled";
import CheckBox from "../../../../../../components/checkbox/Checkbox";
import * as appointmentActions from "../../../../../../store/actions/appointment";
import { useAppDispatch } from "../../../../../..";
import { Alert } from "@mui/material";
import { useSelector } from "react-redux";
import { stat } from "fs";
export interface ModalAttendanceProps {
  modalOpen: boolean;
  idAtendimento: string;
  onCloseModal: () => void;
}

const ModalAttendance: React.FC<ModalAttendanceProps> = ({
  modalOpen,
  idAtendimento,
  onCloseModal,
}) => {
  const { isMobile } = useResponsiveInfo();
  const dispatch = useAppDispatch();

  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [arrayImpression, setArrayImpression] = useState<any>([]);
  const [message, setMessage] = useState<any>([]);
  const [optionsImpremiveis, setOptionsImpremiveis] = useState<any[]>([]);
  const { statusImpressao } = useSelector((state: any) => state.appointment);

  const removeElementArrayList = (value: string) => {
    const i = arrayImpression.findIndex((x: any) => x === value);
    const listClone = [...arrayImpression];
    listClone.splice(i, 1);
    setArrayImpression([...listClone]);
  };

  const fetchPdfs = useCallback(async () => {
    setMessage([]);
    await dispatch(appointmentActions.getPdfs(idAtendimento, arrayImpression));
  }, [arrayImpression, idAtendimento]);

  const fetchImprimiveis = async () => {
    const arrays = await appointmentActions.fetchImprimiveis();

    setOptionsImpremiveis(arrays);
  };

  const atualizationImpression = (dadosValue: any, active: boolean) => {
    active
      ? removeElementArrayList(dadosValue)
      : setArrayImpression((prevList: any) => [...prevList, dadosValue]);
  };

  useEffect(() => {
    fetchImprimiveis();
  }, []);

  useEffect(() => {
    arrayImpression.length > 0
      ? setButtonDisabled(false)
      : setButtonDisabled(true);
  }, [arrayImpression]);

  useEffect(() => {
    if (statusImpressao == "N"){
      setMessage("Impressão não gerou resultados.");
    }
    else if (statusImpressao == "S"){
      setMessage('Impressão gerada com sucesso.');
    }
  }, [statusImpressao]);

  return (
    <AttendanceCardModal open={modalOpen}>
      <AttendanceCardModalContainer isMobile={isMobile}>
        <ModalAttendanceCardContainer>
          <ModalAttendanceTextCardContainer>
            <H1
              style={{
                fontSize: "36px",
              }}
              color={Colors.SPM600}
            >
              Impressão de registro
            </H1>
            {message.length !== 0 && (
              <Alert
                severity= {statusImpressao=="S"? "success": "warning"}
                variant="filled"
                onClose={() => {
                  setMessage([]);
                }}
              >
                {message}
              </Alert>
            )}
          </ModalAttendanceTextCardContainer>
          <Spacer bottom={20} />
          <AttendanceModalOverFlow isMobile={isMobile}>
            <TitleLarge style={{ fontSize: "20px" }}>
              Selecione documentos
            </TitleLarge>
            {optionsImpremiveis?.map((d, index) => (
              <CheckBox
                key={index}
                title={d.nome}
                variavel={d.codigo}
                onClick={atualizationImpression}
              />
            ))}
          </AttendanceModalOverFlow>

          <Spacer bottom={10} />
          <ModalAttendanceButtonsContainer>
            <Button
              onClick={() => {
                onCloseModal();
                setMessage([]);
                setArrayImpression([]);
              }}
              color={Colors.lightBlue}
              backgroundColor={Colors.WHITE}
              borderColor={Colors.lightBlue}
            >
              Cancelar
            </Button>
            <Button
              onClick={() => fetchPdfs()}
              color={Colors.WHITE}
              backgroundColor={Colors.SPM600}
              disabled={buttonDisabled}
            >
              Imprimir
            </Button>
          </ModalAttendanceButtonsContainer>
        </ModalAttendanceCardContainer>
      </AttendanceCardModalContainer>
    </AttendanceCardModal>
  );
};

export default ModalAttendance;
